import React from 'react';
import wrapStore from '@src/utils/wrap-store';
import newPageStore from '@src/pages/main/components/newPage/store';
import cx from 'classnames';
import BaseSwiper from '@src/components/swiper/base-swiper';
import formatLocaleDate from '@src/utils/format-locale-date';
import toWebpImage from '@src/utils/to-webp-image';

// import formatLocaleDate from '@src/utils/format-locale-date';

const styles = require('./index.less');

const newPage = ({ store }) => {
  store.use();

  const handleClick = e => {
    const target = e.target;
    if (target.className === 'NewsInformationList-img') {
      const item = store.NewsInformationList[target.getAttribute('data-btn')];
      store.toDetails(item.contentId);
    }
  };
  const informationSwiper = () => {
    //console.log(store.NewsInformationList?.length);
    if (store.NewsInformationList?.length > 0) {
      return (
        <div className="informationSwiper" onClick={handleClick}>
          <BaseSwiper store={store.informationSwiper}>
            {store.NewsInformationList.map((item, index) => {
              return (
                <div key={index} className="NewsInformationList-item">
                  {/* <div data-btn={index} className={cx('NewsInformationList-img')} style={{ backgroundImage: `url(${item.thumb})` }} /> */}
                  <div data-btn={index} className={cx('NewsInformationList-img')}>
                    <img src={item?.thumb} alt="新闻图" />
                  </div>
                  {/* <div className="NewsInformationList-text">{item.title}</div> */}
                </div>
              );
            })}
          </BaseSwiper>
        </div>
      );
    }
  };

  return (
    <div className={cx(styles.root, store.isActive && styles.rootAvtive)}>
      <div className={styles.content}>
        <div className={styles.title} style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/title.png'))})` }} />
        <div className="moreBox">
          <div className="indicator">
            {store.NewsInformationList?.map((item, index) => {
              return <div key={index} className={cx('indicator-item', store.informationSwiper.activeIndex === index && 'indicator-item-act')} />;
            })}
          </div>
          <div className="line" />
          <div
            className="more"
            onClick={() => store.toList()}
            style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/more-btn.png'))})` }}
          />
        </div>
        {store?.NewsInformationList?.length === 0 ? <div className="zw" /> : informationSwiper()}

        <div className="tab">
          {store.part3Date?.article_tabs.map((item, index) => {
            return (
              <div
                key={index}
                className={cx('tab-item', item.tab_key === store.tabActive && 'active' + (index + 1))}
                onClick={() => store.changeTab(item.tab_key)}
              >
                {item.tab_title}
              </div>
            );
          })}
        </div>
        <div className={cx('tab-content', store.Animating && 'fade-in')}>
          {store.part3Date?.article_contents[store.tabActive].length > 0 ? (
            store.part3Date?.article_contents[store.tabActive]
              .sort((a, b) => b.publishedAt - a.publishedAt)
              .slice(0, 5)
              .map((item, index) => {
                return (
                  <div key={index} className="tab-content-item" onClick={() => store.toDetails(item.contentId)}>
                    {store.tabName[item.tab_key] ? <div className="iconx">{store.tabName[item.tab_key]}</div> : <div className="icon1"></div>}
                    <div className="text">{item.title}</div>
                    <div className="time">{formatLocaleDate(item.publishedAt)}</div>
                  </div>
                );
              })
          ) : (
            <div
              className="not_data_tips"
              style={{ backgroundImage: `url(${toWebpImage(require('./images/' + store.mainStore.Lang() + '/not_data_tips.png'))})` }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default wrapStore(newPage, newPageStore);
